export default __webpack_public_path__ + "static/media/dog4.564c9dfc.svg";